import {
    Button,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
} from "@mui/material";
import {useState } from "react";

interface FocalPointFormParams {
    showFocalPoint: boolean;
    image: string | undefined,
    hideFocalPoint : any,
    saveFocalPoint : any,
}
const FocalPointForm = ({ showFocalPoint, image, hideFocalPoint, saveFocalPoint}: FocalPointFormParams) => {

    const [focalPoint, setFocalPoint] = useState("");

    const getFocalPoints = (event : any) => {
        const rect = event.target.getBoundingClientRect();
        const x = event.clientX - rect.left;
        const y = event.clientY - rect.top;

        const xPercent = (x / rect.width) * 100;
        const yPercent = (y / rect.height) * 100;

        const redSpot = document.createElement('div');
        redSpot.classList.add('red-spot');
        redSpot.style.position = 'absolute'; // Ensure the red spot is positioned absolutely
        redSpot.style.left = `${x}px`; // Use actual x coordinate
        redSpot.style.top = `${y}px`;  // Use actual y coordinate

        const existingSpots = event.currentTarget.parentElement?.querySelectorAll('.red-spot');
        existingSpots?.forEach((spot : any) => spot.remove());

        event.currentTarget.parentElement?.append(redSpot); // Append the

        const objectPosition = `${xPercent.toFixed(2)}% ${yPercent.toFixed(2)}%`;
        setFocalPoint(objectPosition);
    };

    return (
        <Dialog className="focal_point_selector" open={showFocalPoint}>
        <DialogTitle>Select Focal Point</DialogTitle>
        <DialogContent>
            <div style={{position: "relative"}}>
                <img 
                onClick={getFocalPoints}
                src={image} alt="profile picture" />
            </div>
        </DialogContent>
        <DialogActions>
            <Button onClick={hideFocalPoint} color="primary">
                Cancel
            </Button>
            <Button 
            color="secondary"
            onClick={()=>{saveFocalPoint(focalPoint); hideFocalPoint()}}>
                Save
            </Button>
        </DialogActions>
    </Dialog>
  );
}

export default FocalPointForm;